import {useMutation, gql} from '@apollo/client'

export const MUTATE_CREATE_USER = gql`
  mutation MUTATE_CREATE_USER(
    $email: Email!
    $groupId: Numeric!
    $firstName: Customname!
    $lastName: Customname!
    $startDate: Date!
    $endDate: Date
    $isTemporary: Boolean!
  ) {
    createUser(
      email: $email
      groupId: $groupId
      firstName: $firstName
      lastName: $lastName
      startDate: $startDate
      endDate: $endDate
      isTemporary: $isTemporary
    ) {
      createUser {
        group_id
        email
        first_name
        last_name
        start_date
        end_date
        is_temporary
      }
    }
  }
`

export function useAddUser() {
  return useMutation(MUTATE_CREATE_USER, {
    context: {clientName: 'adminPanel'},
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  })
}
